import React from 'react';
import { useTranslation } from 'react-i18next';
import TextBox from './TextBox';
import Button from './Button';

/**
 * SearchBar: Inline search bar with TextBox + 검색 Button.
 * Used in reservation pages (ReservationList, ReservationDetail, GuestReservation).
 *
 * Renders as a flex row: TextBox fills remaining space (flex-1), Button stays fixed width.
 * Parent handles layout context (max-w, padding, spacing).
 */
export default function SearchBar({ placeholder, value, onChange, onSubmit, buttonLabel, leftIcon, error, hint }) {
  const { t } = useTranslation();
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && onSubmit) onSubmit();
  };

  return (
    <div className="flex gap-1 items-start">
      <div className="flex-1 min-w-0">
        <TextBox
          bg="white"
          placeholder={placeholder || t('common.search')}
          value={value || ''}
          onChange={onChange}
          onKeyDown={handleKeyDown}
          leftIcon={leftIcon}
          error={error}
          hint={hint}
        />
      </div>
      <Button level="level2" className="shrink-0 mt-0" onClick={onSubmit}>{buttonLabel || t('common.search')}</Button>
    </div>
  );
}
